import Link from 'next/link';
import React from 'react';

type Props = {
    tableData: TableData;
};

export type TableData = {
    columns: TableColumn[];
    rows: TableRow[];
};

export type TableRow = {
    columnData: string[];
    hyperlinkData?: string[];
};

export type TableColumn = {
    columnName: string;
    columnClasses?: string;
};

export const Table: React.FC<Props> = ({ tableData }) => {
    const columns = tableData.columns;
    const rows = tableData.rows;
    return (
        <div className="table-container">
            <table className="table">
                <thead className="table-head">
                    {columns.map((column, index) => (
                        <th
                            className={`table-heading${column.columnClasses ? ` ${column.columnClasses}` : ''}`}
                            key={`table-heading-${index}`}
                        >
                            {column.columnName}
                        </th>
                    ))}
                </thead>
                <tbody className="table-body">
                    {rows.map((row, i) => (
                        <tr className="table-row" key={`table-row-${i}`}>
                            {row.columnData.map((data, j) => (
                                <td
                                    className={`table-data${
                                        columns[j].columnClasses ? ` ${columns[j].columnClasses}` : ''
                                    }`}
                                    key={`table-data-${i}-${j}`}
                                >
                                    {!!row.hyperlinkData[j] ? (
                                        <Link href={row.hyperlinkData[j]}>
                                            <a>{data}</a>
                                        </Link>
                                    ) : (
                                        data
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
